import React, { useState } from "react";

import SendIcon from "@mui/icons-material/Send";
import {
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import { withStyles } from "tss-react/mui";

import Visibility from "../../../../../../components/layout/Visibility";

interface Props {
  value: string;
  onChangeText: (value: string) => void;
  onSubmit: (value: string) => Promise<void>;
}

const CommentField = withStyles(TextField, {
  root: {
    width: "100%",
    "& .MuiInputBase-root": {
      fontSize: 14,
    },
  },
});

const SendAdornment = withStyles(InputAdornment, {
  root: {
    marginRight: -12,
  },
});

const ExerciseCommentField: React.FC<Props> = ({
  value,
  onChangeText,
  onSubmit = Promise.resolve,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const callSubmitHandler = () => {
    setIsSubmitting(true);
    onSubmit(value ?? "").finally(() => setIsSubmitting(false));
  };

  return (
    <>
      <CommentField
        placeholder="Write comments"
        size="small"
        value={value}
        multiline
        InputProps={{
          endAdornment: (
            <>
              <Visibility visible={!!value}>
                <SendAdornment position="end">
                  <IconButton
                    color="primary"
                    onClick={callSubmitHandler}
                    disabled={isSubmitting}
                    size="large"
                  >
                    <SendIcon />
                  </IconButton>
                </SendAdornment>
              </Visibility>
              <Visibility visible={isSubmitting} shouldCollapse>
                <InputAdornment position="end">
                  <CircularProgress size="1rem" />
                </InputAdornment>
              </Visibility>
            </>
          ),
        }}
        onChange={(event) => onChangeText(event.target.value)}
        onKeyPress={(event) => {
          if (event.key === "Enter") callSubmitHandler();
        }}
        disabled={isSubmitting}
      />
    </>
  );
};

export default ExerciseCommentField;
